import { render } from "./LabsCard.vue?vue&type=template&id=395ea6e4&scoped=true"
import script from "./LabsCard.vue?vue&type=script&lang=js"
export * from "./LabsCard.vue?vue&type=script&lang=js"

import "./LabsCard.vue?vue&type=style&index=0&id=395ea6e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395ea6e4"]])

export default __exports__